// extracted by mini-css-extract-plugin
export default {"referensforsaljningarTable":"Referensforsaljningar_referensforsaljningarTable__zxw76"};